import axios from 'axios';

// 平台驾驶舱概览(在线实例/总净值/当日盈亏/待执行指令)
export const getPlatformOverview = async () => {
  try {
    const response = await axios.get('/api/dashboard/platform');
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: '获取平台概览失败' };
  }
};

// 实例列表(每实例最新一条快照 + 汇总)
export const getInstances = async () => {
  try {
    const response = await axios.get('/api/monitor/instances');
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: '获取实例列表失败' };
  }
};

// 单实例历史曲线
export const getInstanceHistory = async (instanceId, range = '24h') => {
  try {
    const response = await axios.get('/api/monitor/history', {
      params: { instanceId, range }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: '获取历史数据失败' };
  }
};

// 全实例聚合历史曲线(按权限范围内所有实例分桶求和)
export const getAggregateHistory = async (range = '24h') => {
  try {
    const response = await axios.get('/api/monitor/aggregate', {
      params: { range }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: '获取聚合曲线失败' };
  }
};
